<template>
  <div class="packages-list">
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @submit="handleSearch" @submit.native.prevent>
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="站点">
                <station-select type="input" v-model="search.station" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="单号">
                <a-input placeholder="输入单号(支持模糊查询)" v-model="search.code" allowClear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-model-item label="电话">
                <a-input placeholder="输入电话" v-model="search.phone" allowClear/>
              </a-form-model-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-model-item label="取件码">
                  <a-input placeholder="输入取件码" v-model="search.secret" allowClear/>
                </a-form-model-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-model-item label="状态" style="width: 100%;">
                  <a-select v-model="search.status" placeholder="选择状态" allowClear style="width: 160px;">
                    <a-select-option value="0">未取</a-select-option>
                    <a-select-option value="1">已取</a-select-option>
                    <a-select-option value="2">撤回</a-select-option>
                    <a-select-option value="9">异常</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-model-item label="电话">
                  <a-input placeholder="输入快递员电话" v-model="search['partner.mobile']" allowClear/>
                </a-form-model-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-model-item label="编号">
                  <a-input placeholder="输入格子编号" v-model="search['cabinet.serial']" allowClear/>
                </a-form-model-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-model-item label="公司">
                  <company-search
                      v-model="search.company"
                      placeholder="请选择所属公司"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :md="7" :sm="12">
                <a-form-model-item label="入站时间">
                  <a-range-picker
                    v-model="intimeRange"
                    format="YYYY-MM-DD"
                    valueFormat="YYYY-MM-DD"
                    style="width:200px"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :md="7" :sm="12">
                <a-form-model-item label="出站时间">
                  <a-range-picker
                    v-model="outttimeRange"
                    format="YYYY-MM-DD"
                    valueFormat="YYYY-MM-DD"
                    style="width:200px"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :md="3" :sm="6">
                <a-form-model-item label="状态" style="width: 100%;">
                  <a-select v-model="search.isSecretWayBill" placeholder="是否隐私面单" allowClear style="width: 60px;">
                    <a-select-option value="">全部</a-select-option>
                    <a-select-option value="1">是</a-select-option>
                    <a-select-option value="0">否</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :md="3" :sm="6">
                <a-form-model-item label="短信" style="width: 100%;">
                  <a-select v-model="search.mtype" placeholder="短信状态" allowClear style="width: 60px;">
                    <a-select-option value="">全部</a-select-option>
                    <a-select-option value="0">成功</a-select-option>
                    <a-select-option value="11">失败</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :md="4" :sm="6">
                <a-form-model-item label="来源平台" style="width: 100%;">
                  <a-select v-model="search.etype" placeholder="来源平台" allowClear style="width: 90px;">
                    <a-select-option value="">全部</a-select-option>
                    <a-select-option value="taobao">淘宝</a-select-option>
                    <a-select-option value="pdd">拼多多</a-select-option>
                    <a-select-option value="douyin">抖音</a-select-option>
                    <a-select-option value="jd"> 京东</a-select-option>
                    <a-select-option value="other">其他</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-model-item label="快递公司" style="width: 100%;">
                  <a-select v-model="pinyin" placeholder="选择快递公司" allowClear style="width: 160px;">
                    <a-select-option value="">全部</a-select-option>
                    <a-select-option value="zhongtong">中通</a-select-option>
                    <a-select-option value="yunda">韵达</a-select-option>
                    <a-select-option value="youzheng">邮政</a-select-option>
                    <a-select-option value="jtexpress">极兔</a-select-option>
                    <a-select-option value="shengtong">申通</a-select-option>
                    <a-select-option value="jd">京东</a-select-option>
                    <a-select-option value="shunfeng">顺丰</a-select-option>
                    <a-select-option value="ems">EMS</a-select-option>
                    <a-select-option value="yuantong">圆通</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :md="6" :sm="6">
                <a-form-model-item label="名字" style="width: 100%;">
                  <a-select v-model="search.nameIsNull" placeholder="是否存在名字" allowClear style="width: 120px;">
                    <a-select-option value="">全部</a-select-option>
                    <a-select-option value="1">不存在</a-select-option>
                    <a-select-option value="0">存在</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" html-type="submit">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetSearchForm">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-divider />
      <a-table
          :loading="listloading"
          :columns="columns"
          :data-source="list"
          rowKey="_id"
          :bordered="false"
          :scroll="{ x: 1700, y: listTableHeight + 60 }"
          :pagination="pager"
          size="small"
          @change="change"
        >
        <span slot="partner" slot-scope="text, record">
          <excom-icon :excom="record.partner.pinyin" :text="record.partner.name" @changePartner="changePartner(record)" />
          {{ record.partner.mobile }}
        </span>
        <span slot="code" slot-scope="text, record">
          <div style="display: none;">{{ getEtypeImg(record.etype) }}</div>
          <img :src="getEtypeImg(record.etype)" :alt="record.etype" style="width: 16px; margin-right: 4px">
          <a-tooltip>
            <template slot="title">
              {{ record.code }}
            </template>
            <a @click="openDetail(record._id)">{{ record.code }}</a>
            <a-icon type="search" @click="openKuaid100(record.partner.pinyin, record.code)" />
          </a-tooltip>
        </span>
        <span slot="waybillUrl" slot-scope="text, record" v-if="text">
            <img style="width: 40px; height: 40px; margin-right:10px" :src="text + '?imageMogr2/thumbnail/40x'" :data-source="text" @click="previewURL(text)">
            <a-icon type="search" @click="ocrWaybill(record)"></a-icon>
        </span>
        <span slot="status" slot-scope="text">
          <span v-if="text === 1">
            <a-badge status="success" />已取
          </span>
          <span v-if="text === 0">
            <a-badge status="processing" />未取
          </span>
          <span v-if="text === 2">
            <a-badge status="warning" />撤回
          </span>
          <span v-if="text === 9">
            <a-badge status="error" />异常
          </span>
        </span>
        <span slot="boxSize" slot-scope="text">
          <a-tag color="#2db7f5">{{ boxTag[text] }}</a-tag>
        </span>
        <span slot="phone" slot-scope="text,record">
          <span class="phone-edit">
            <span>{{ text }}</span>
            <a-icon type="search" @click="searchCustom(record)" v-if="record.phone.includes('*')"></a-icon>
            </br>
            <span>
              <a-tag color="green" v-if="record.city">
                {{ record.city }}
              </a-tag>
              <span>{{record.name}}</span>
            </span>
            <a-icon type="edit" @click="modifyPhone(record._id, text)" />
            <a-icon type="search" @click="gussCustomerName(record)" v-if="!record.name && !record.phone.includes('*')"></a-icon>
            <a-icon type="search" @click="updateCustomerName(record)" v-if="record.etype === 'taobao' && record.phone.includes('*')"></a-icon>
          </span>
        </span>
        <div slot="mtype" slot-scope="text, record">
          <div>
            <span v-if="record.mtype === '0'">
              <a-icon type="mail" style="color: blue" />
              短信
            </span>
            <span v-if="record.mtype === '1'">
              <a-icon type="message" style="color: green" />
              微信
            </span>
            <span v-if="record.mtype === '11'" @click="smsResend(record._id)">
              <a-icon type="info-circle" style="color: red" />
              回执失败
            </span>
            <span v-if="record.mtype === '9'">
              <a-icon type="clock-circle" style="color: red" />
              等待发送
            </span>
          </div>
          <div>
            <span v-if="record.wtype === '0'">
              <a-icon type="message" style="color: blue" />
              未发送
            </span>
            <span v-if="record.wtype === '1'">
              <a-icon type="message" style="color: green" />
              微信模版
            </span>
            <span v-if="record.wtype === '11'">
              <a-icon type="warning" style="color: red" />
              发送失败
            </span>
            <span v-if="record.wtype === '9'">
              <a-icon type="disconnect" style="color: red" />
              未关注
            </span>
          </div>

        </div>
        <span slot="action" slot-scope="text, record">
          <a-popconfirm
            title="你确定要开箱么?"
            ok-text="确定"
            cancel-text="放弃"
            @confirm="openBox(record._id)"
            v-if="record.status === 0"
          >
            <a-button style="padding: 0" type="link">开箱</a-button>
          </a-popconfirm>
          <a-button v-else style="padding: 0" type="link" :disabled="record.status !== 0">开箱</a-button>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link" @click="e => e.preventDefault()">
              更多<a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-button
                  type="link"
                  @click="outbound(record._id)"
                  icon="enter"
                  size="small"
                  :disabled="record.status === 1"
                >出站</a-button>
              </a-menu-item>
              <a-menu-item>
                <a-button
                  type="link"
                  icon="rollback"
                  :disabled="record.status === 0"
                  @click="inboundAgainAction(record._id)"
                  size="small"
                >重新入站</a-button>
              </a-menu-item>
              <a-menu-item>
                <a-button
                  type="link"
                  icon="check"
                  :disabled="record.status === 1 && record.freeOfCharge"
                  @click="freeCharge(record._id)"
                  size="small"
                >超期免单</a-button>
              </a-menu-item>
              <a-menu-item>
                <a-button
                  type="link"
                  icon="form"
                  :disabled="!record.isSecretWayBill" 
                  @click="openSecretUserDialog(record)"
                  size="small"
                >可信隐私号设置</a-button>
              </a-menu-item>
              <a-menu-item>
                <a-button
                  type="link"
                  icon="edit"
                  @click="openUDialog(record)"
                  size="small"
                >更新收件人信息</a-button>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </a-card>
    <a-modal
      title="修改收件人电话"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="modifyPhoneSubmit"
      @cancel="handleCancel"
    >
      <a-form :form="modifyPhoneForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
        <a-form-item label="通知发送">
          <a-radio-group name="radioGroup" :default-value="1" v-model="modifyPhoneForm.sendNotice">
            <a-radio :value="1">发送信息</a-radio>
            <a-radio :value="0">不发送信息</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="修改的电话">
          <a-input v-model="modifyPhoneForm.phone"  />
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal
      title="设置可信的隐私号码"
      :visible="secretPhoneVisible"
      width="720px"
      @ok="secretPhoneVisible = false"
      @cancel="secretPhoneVisible = false"
    >
      <a-table
        :loading="listloading"
        :columns="userColumns"
        :data-source="secretUserList"
        rowKey="_id"
        :pagination="false"
        @change="change"
      >
      <span slot="trustedSecrePhone" slot-scope="text">
        <a-tag color="red" v-for="item in text" :key="item" style="margin-left: 2px">{{ item }}</a-tag>
      </span>
        <span slot="action" slot-scope="text, record">
          <a @click="setUserSecret(record._id)">设置</a>
          <a-divider type="vertical" />
          <a @click="deleteCustom(record)" v-has:deleteCustom>删除</a>
			</span>
      </a-table>
    </a-modal>
    <Detail ref="detail" />
    <a-modal 
      v-model="dialogTableVisible" 
      title="相关联系方式" 
      on-ok="handleOk"
      :footer="false"
    >
      <a-table 
        size="small"
        :pagination="false"
        :columns="[
            {
              title: '姓名',
              dataIndex: 'name',
              key: 'name',
            },
            {
              title: '电话',
              dataIndex: 'phone',
              key: 'phone',
            },
            {
              title: '地址',
              dataIndex: 'address',
              key: 'address',
            },
            {
              title: '计数',
              dataIndex: 'count',
              key: 'count',
            }
          ]" 
          :data-source="gridData"
      >
      </a-table>
    </a-modal>
    <a-modal
      title="更新收件人信息"
      :visible="uvisible"
      :confirm-loading="confirmLoading"
      @ok="udialogSubmit"
      @cancel="handleUdialogCancel"
    >
      <div style="display: flex; justify-content: center;">
        <barcode 
          :value="customform.code" 
          format="CODE128" 
          :options="{
            size: 100,
          }"
        >
          Show this if the rendering fails.
        </barcode>
      </div>
      <a-form :form="customform" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
        <a-form-model-item label="姓名" prop="name">
          <a-input 
            v-model="customform.name" 
            placeholder="输入客户姓名" 
            allowClear 
            prop="name"
          ></a-input>
        </a-form-model-item>
        <a-form-model-item label="电话" prop="phone">
          <a-input 
            v-model="customform.phone" 
            placeholder="输入客户电话" 
            allowClear
            prop="phone"
          ></a-input>
        </a-form-model-item>
        <a-form-model-item label="地址" prop="address">
          <a-input 
            v-model="customform.address" 
            placeholder="输入客户地址" 
            allowClear 
            prop="address"
          ></a-input>
        </a-form-model-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import {
  packagesList,
  modifyPackage,
  packageOpenBox,
  inboundAgain,
  resendSms,
  setFreeOfCharge,
  outbound,
  updateOcrResult,
} from '@/api/bussiness';
import {
  getSecretUser, 
  setSecretUser, 
  deleteCustom, 
  updateCustomerName,
  gussCustomer,
  stationUser,
  updateCustomer,
  creatCustomer,
  changePatnerAction,
} from '@/api/user';
import { ocrWaybillByPkId } from '@/api/common';
import { mapGetters } from 'vuex';
import Detail from './detail.vue';
import pdd from '../../assets/pdd.jpeg';
import taobao from '../../assets/taobao.jpg';
import jd from '../../assets/jd.jpg';
import other from '../../assets/other.jpg';
import douyin from '../../assets/douyin.png';
import barcode from 'vue-barcode';
import { api as viewerApi } from "v-viewer"
const columns = [
  {
    title: '站点名称',
    dataIndex: 'station.name',
    key: 'stationName',
    width: 130,
    ellipsis: true,
    fixed: 'left',
  },
  {
    title: '单号',
    dataIndex: 'code',
    key: 'code',
    width: 150,
    ellipsis: true,
    scopedSlots: { customRender: 'code' },
    fixed: 'left',
  },
  {
    title: '状态',
    dataIndex: 'status',
    key: 'status',
    ellipsis: true,
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '电话',
    dataIndex: 'phone',
    key: 'phone',
    width: 140,
    scopedSlots: { customRender: 'phone' },
  },
  {
    title: '底单',
    dataIndex: 'waybillUrl',
    key: 'waybillUrl',
    scopedSlots: { customRender: 'waybillUrl' },
  },
  {
    title: '虚拟小号',
    dataIndex: 'virtualNumber',
    key: 'virtualNumber',
  },
  {
    title: '取件码',
    dataIndex: 'secret',
    key: 'secret',
  },
  {
    title: '信息状态',
    dataIndex: 'mtype',
    key: 'mtype',
    width: 120,
    scopedSlots: { customRender: 'mtype' },
  },
  {
    title: '快递员',
    dataIndex: 'partner.name',
    key: 'partnerName',
    width: 120,
    scopedSlots: { customRender: 'partner' },
  },
  {
    title: '单价',
    dataIndex: 'unitprice',
    key: 'unitprice',
  },
  {
    title: '编号',
    dataIndex: 'cabinet.serial',
    key: 'cabinetSerial',
  },
  {
    title: '格子型号',
    dataIndex: 'boxSize',
    key: 'boxSize',
    scopedSlots: { customRender: 'boxSize' },
  },
  {
    title: '投递时间',
    dataIndex: 'intime',
    width: 120,
    key: 'intime',
  },
  {
    title: '取件时间',
    dataIndex: 'outtime',
    key: 'outtime',
  },
  {
    title: '备注',
    key: 'desc',
    dataIndex: 'desc',
  },
  {
    title: '操作',
    key: 'action',
    fixed: 'right',
    width: 140,
    scopedSlots: { customRender: 'action' },
  },
];
export default {
  components: { Detail, barcode },
  data() {
    return {
      columns,
      visible: false,
      confirmLoading: false,
      modifyPhoneForm: {},
      listloading: false,
      dialogTableVisible: false,
      uvisible: false,
      gridData: [],
      search: {
      },
      pinyin: "",
      id: '',
      list: [],
      pager: {},
      intimeRange: [],
      outttimeRange: [],
      advanced: false,
      secretPhoneVisible: false,
      secretUserList: [],
      record: null,
      customform: {

      },
      boxTag: {
        mini: '迷你',
        small: '小',
        middle: '中',
        big: '大',
      },
    };
  },
  created() {
    this.search = this.$route.query;
    this.getList();
  },
  computed: {
    ...mapGetters(['listTableHeight']),
    userColumns() {
      return [
        {
          title: '站点',
          dataIndex: 'station.name',
          key: 'stationName',
        },
        {
          title: '用户姓名',
          dataIndex: 'name',
          key: 'name',
        },
        {
          title: '电话',
          dataIndex: 'phone',
          key: 'phone',
        },
        {
          title: '包裹计数',
          dataIndex: 'count',
          key: 'count',
        },
        {
		      title: '可信隐私号',
          dataIndex: 'trustedSecrePhone',
		      key: 'trustedSecrePhone',
		      scopedSlots: { customRender: 'trustedSecrePhone' },
	      },
	      {
		      title: '操作',
		      key: 'action',
		      fixed: 'right',
		      width: 120,
		      scopedSlots: { customRender: 'action' },
	      },
      ];
    },
  },
  methods: {
    getEtypeImg(type) {
      if (type == 'taobao') {
        return taobao;
      }
      if (type == 'jd') {
        return jd;
      }
      if (type == 'pdd') {
        return pdd;
      }
      if (type == 'douyin') {
        return douyin;
      }
      if (type == 'other') {
        return other;
      }
    },
    async getList() {
      this.listloading = true;
      try {
        const { data: { docs, pager } } = await packagesList({
          ...this.search,
          intimeStart: this.intimeRange[0],
          intimeEnd: this.intimeRange[1],
          outtimeStart: this.outttimeRange[0],
          outtimeEnd: this.outttimeRange[1],
          "partner.pinyin": this.pinyin,
        });
        this.list = docs;
        this.pager = {
          ...pager,
          showTotal: (total) => `共计 ${total} 条信息`,
        };
      } catch (e) {
        console.error(e);
      }
      this.listloading = false;
    },
    change(pagination) {
      this.search.page = pagination.current;
      this.getList();
    },
    handleSearch() {
      this.search.page = 1;
      this.getList();
    },
    modifyPhone(id, phone) {
      this.visible = true;
      this.id = id;
      this.modifyPhoneForm.phone = phone;
    },
    async gussCustomerName(row) {
      const {phone, station} = row;
      const res = await updateCustomerName(phone, station._id);
      if(res.code == 0) {
        this.$message.success(res.data.message);
      } else {
        this.$message.error(res.message);
      }
      this.getList();
    },
    searchCustom(row) {
      this.dialogTableVisible = true;
      this.getCustomerList({
        phone: row.phone.slice(7,11),
        station: row.station._id,
      })
    },
    async getCustomerList(q) {
      try {
        const { data: { docs } } = await stationUser(q);
        this.gridData = docs;
      } catch (e) {
        console.error(e);
      }
    },
    async updateCustomerName(row) {
      const hide = this.$message.loading('数据处理中', 0);
      const res = await gussCustomer({ id: row._id });
      hide();
      if (res.code == 0) {
        this.$message.success('更新成功');
      }
      this.getList();
    },
    async udialogSubmit() {
      const { edit, phone, id, name, station, address,virtualNumber, pkid } = this.customform;
      let res
      if(edit) {
        res = await updateCustomer({
          station,
          id,
          phone,
          name,
          address,
        })
        await updateOcrResult(pkid, {name, virtualNumber})
      } else {
        res = await creatCustomer({
          station,
          name,
          phone,
          address
        })
      }
      if(res && (res.data.code == 0 || res.code == 0)) {
        this.$message.success('操作成功');
        this.uvisible = false;
        this.getList();
      }
    },
    handleCancel() {
      this.visible = false;
    },
    handleUdialogCancel() {
      this.uvisible = false;
    },
    async openUDialog(row) {
      this.customform = {};
      if(row.etype !== 'pdd') {
          const hide = this.$message.loading('获取数据中...', 0);
          const { data } = await packagesList({
            station: row.station._id,
            phone: row.phone,
            etype: 'pdd',
          })
          if(data.docs && data.docs.length > 0) {
            this.customform.code = data.docs[0].code;
          }
          hide();
      }
      if(!row.phone.includes("*")) {
        const hide = this.$message.loading('获取数据中...', 0);
        const { data: { docs }  } = await stationUser({
          station: row.station._id,
          phone: row.phone,
        })
        this.customform.phone = docs[0].phone;
        this.customform.name = docs[0].name;
        this.customform.id = docs[0]._id;
        this.customform.address = docs[0].address;
        this.customform.edit = true;
        hide();
      } else {
        this.customform.edit = false;
      }
      this.customform.station = row.station._id;
      this.customform.code = this.customform.code || row.code;
      this.customform.phone = row.phone;
      this.customform.pkid = row._id;
      this.uvisible = true;
    },
    async modifyPhoneSubmit() {
      const postData = this.modifyPhoneForm;
      this.confirmLoading = true;
      const { data } = await modifyPackage(this.id, postData);
      if (data) {
        this.$message.success('修改成功');
        this.handleCancel();
        this.getList();
      }
      this.confirmLoading = false;
    },
    async openBox(id) {
      const hide = this.$message.loading('开箱中请等待..', 0);
      const res = await packageOpenBox(id);
      if (res.data && res.data.success) {
        this.$message.success('开箱成功');
      } else {
        this.$message.error(res.data.msg);
      }
      hide();
      this.getList();
    },
    async outbound(id) {
      const hide = this.$message.loading('出站中..', 0);
      try {
        const res = await outbound(id);
        if (res) {
          this.$message.success('出站成功');
        }
      } catch (error) {
        this.$message.error(JSON.stringify(error));
      }
      hide();
      this.getList();
    },
    async inboundAgainAction(id) {
      await inboundAgain(id,1)
      this.$message.success('操作成功');
      this.getList();
    },
    openKuaid100(pinyin, code) {
      const url = `https://www.kuaidi100.com/chaxun?com=${pinyin}&nu=${code}`;
      window.open(url, '物流信息查询', 'location=no,channelmode=yes,width=800,height=800');
    },
    openDetail(id) {
      this.$refs.detail.show(id);
    },
    toggleAdvanced() {
      this.advanced = !this.advanced;
    },
    async smsResend(id) {
      await resendSms(id);
      this.$message.success('操作成功');
      this.getList();
    },
    async freeCharge(id) {
      await setFreeOfCharge(id);
      this.$message.success('操作成功');
      this.getList();
    },
    resetSearchForm() {
      this.search = {
      };
      this.intimeRange = [];
      this.outtimeRange = [];
    },
    async openSecretUserDialog(record) {
      this.secretPhoneVisible = true;
      this.record = record;
      this.getSecretUserList();
    },
    async getSecretUserList() {
      const { record } = this;
      const { data } = await getSecretUser({ station: record.station.id, phone: record.phone });
      this.secretUserList = data;
    },
    async setUserSecret(customId) {
      const { phone } = this.record;
      await setSecretUser(customId, phone);
      this.getSecretUserList();
      this.$message.success('成功');
    },
    async deleteCustom(record) {
      await deleteCustom(record._id);
      this.$message.success('删除成功');
      this.getList();
    },
    previewURL(url) {
      viewerApi({
        options: {
            toolbar: false,
          },
        script: 'preview',
          images: [url],
      })
    },
    async ocrWaybill(record) {
      const hide = this.$message.loading('面单识别中...', 0);
      const { data } = await ocrWaybillByPkId(record._id);
      if(data.name) {
        const { data: { docs }  } = await stationUser({
          station: record.station._id,
          phone: record.phone,
        })
        this.uvisible = true;
        this.customform.name = data.name;
        this.customform.phone = docs[0].phone;
        this.customform.id = docs[0]._id;
        this.customform.address = data.address;
        this.customform.edit = true;
        this.customform.code = record.code;
        this.customform.virtualNumber = data.virtualNumber || data['virtualNumber-subfix'];
        this.customform.station = record.station._id;
        this.customform.pkid = record._id;
      } else {
        this.$message.error('未识别到有效信息');
      }
      hide();
    },
    async changePartner(record) {
      this.$confirm({
        title: '修改快递员',
        content: '确定修改吗？',
        onOk() {
         changePatnerAction(record._id).then(res => {
           if(res.data.code ===0) {
            that.$message.success('修改成功');
            that.getList();
          }
         })
        },
        onCancel() {},
      });
    }
  },
};
</script>
<style lang="less">
.phone-edit{
  .anticon{
    visibility: hidden;
    cursor: pointer;
    margin-left: 10px;
    &:hover{
      color: #2f54eb;
    }
  }
  &:hover{
    .anticon{
      visibility: visible;
    }
  }
}
</style>
